import { render } from "./ConfigurationBasic.vue?vue&type=template&id=f4798520&scoped=true"
import script from "./ConfigurationBasic.vue?vue&type=script&lang=js"
export * from "./ConfigurationBasic.vue?vue&type=script&lang=js"

import "./ConfigurationBasic.vue?vue&type=style&index=0&id=f4798520&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4798520"]])

export default __exports__